import React from 'react'
import classes from './HR.css'
const HR = () => (
    <div className={classes.HR}></div>
)
export default HR


// WEBPACK FOOTER //
// src/UI/HR/HR.js